'use client';
import React from 'react';
import Link from 'next/link';

interface SupportCard {
  id: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  href: string;
}

const supportCards: SupportCard[] = [
  {
    id: 'expert',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="14" r="7" stroke="#C9A84C" strokeWidth="1.5" />
        <path
          d="M6 34C6 27.37 12.27 22 20 22C27.73 22 34 27.37 34 34"
          stroke="#C9A84C"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    title: 'Chat with an expert',
    description: 'Get personalized event recommendations',
    href: '#chat',
  },
  {
    id: 'support',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="14" stroke="#C9A84C" strokeWidth="1.5" />
        <path
          d="M15 18C15 15.24 17.24 13 20 13C22.76 13 25 15.24 25 18C25 20.76 22.76 23 20 23V25"
          stroke="#C9A84C"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="20" cy="28" r="1.2" fill="#C9A84C" />
      </svg>
    ),
    title: 'Event Support',
    description: 'Help with tickets, refunds, and more',
    href: '#support',
  },
  {
    id: 'tickets',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M6 16C6 14.9 6.9 14 8 14H32C33.1 14 34 14.9 34 16V18C32.9 18 32 18.9 32 20C32 21.1 32.9 22 34 22V24C34 25.1 33.1 26 32 26H8C6.9 26 6 25.1 6 24V22C7.1 22 8 21.1 8 20C8 18.9 7.1 18 6 18V16Z"
          stroke="#C9A84C"
          strokeWidth="1.5"
        />
        <path d="M15 14V26" stroke="#C9A84C" strokeWidth="1.5" strokeDasharray="2 2" />
      </svg>
    ),
    title: 'My Tickets',
    description: 'View and manage your bookings',
    href: '#my-tickets',
  },
  {
    id: 'protection',
    icon: (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M20 6L8 11V20C8 27.18 13.33 33.85 20 35.5C26.67 33.85 32 27.18 32 20V11L20 6Z"
          stroke="#C9A84C"
          strokeWidth="1.5"
        />
        <path
          d="M14 20L18 24L26 16"
          stroke="#C9A84C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: 'Rani Kamlapati Protect',
    description: 'Safe & secure ticket purchases',
    href: '#protection',
  },
];

export default function SupportCards() {
  return (
    <div className="py-8" style={{ margin: '0 48px' }}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {supportCards.map((card) => (
          <Link
            key={card.id}
            href={card.href}
            className="flex flex-col items-center justify-center p-6 text-center transition-all duration-200 cursor-pointer"
            style={{
              background: '#FFFFFF',
              borderRadius: '12px',
              minHeight: '150px',
              border: '1px solid rgba(201,168,76,0.2)',
              boxShadow: '0 2px 8px rgba(26,10,0,0.05)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 20px rgba(26,10,0,0.1), 0 0 0 1px rgba(201,168,76,0.35)';
              (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.boxShadow = '0 2px 8px rgba(26,10,0,0.05)';
              (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
            }}
          >
            <div className="mb-3">{card.icon}</div>
            <p
              className="font-medium text-sm"
              style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}
            >
              {card.title}
            </p>
            <p className="text-xs mt-1" style={{ color: '#8B7355', fontFamily: 'Roboto, sans-serif' }}>{card.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
